import './instrument';                                 // Sentry+PostHog init — ДО React-рендера
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Sentry } from './instrument';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Fallback UI если весь app упал. В дев-режиме просто показываем ошибку, в прод — дружелюбное сообщение.
const ErrorFallback = ({ error, resetError }) => (
  <div style={{ padding: 24, fontFamily: 'sans-serif', color: '#fff', background: '#1a1a1a', minHeight: '100vh' }}>
    <h2>Что-то пошло не так</h2>
    <p>Ошибка отправлена разработчикам. Попробуй перезагрузить страницу.</p>
    {process.env.NODE_ENV !== 'production' && (
      <pre style={{ color: '#f88', whiteSpace: 'pre-wrap' }}>{error?.message}</pre>
    )}
    <button onClick={resetError} style={{ padding: '8px 16px', marginTop: 12 }}>Попробовать снова</button>
  </div>
);

const AppWithBoundary = () => (
  <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
    <App />
  </Sentry.ErrorBoundary>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWithBoundary />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
